// Id firmy (Workspaces.Id) aktywnej w tej sesji.
//
// Następca modułowego mirrora WorkspaceId aktywnego profilu z modelu profili (docs/model-
// kluczy-firmowych.md): profile znikły (D1 — jedna firma na użytkownika, bez przełącznika
// kontekstu), więc firma jest teraz JEDYNYM "workspace", jaki użytkownik ma. Wartość, którą
// dawniej niósł WorkspaceId dawnego aktywnego profilu, to dziś zwyczajnie `ICompany.Id`.
//
// getCompanyId bywa wołane w wielu miejscach jako zwykła funkcja (nie hook), więc nie ma
// dostępu do kontekstu Reacta. Dlatego id aktywnej firmy trzymamy w module-level mirrorze,
// aktualizowanym centralnie przez components/CompanyProvider — jedyne miejsce, które woła
// setActiveCompanyId, w reakcji na zmianę `CompanyContext.company`.

let activeCompanyId: string | null = null;

/** Ustawia id aktywnej firmy (wołane przez CompanyProvider przy zmianie `company`). */
export const setActiveCompanyId = (companyId?: string | null): void => {
  activeCompanyId = companyId ?? null;
};

/** Zwraca id aktywnej firmy (null przed załadowaniem albo dla konta bez firmy — D2). */
export const getCompanyId = (): string | null => activeCompanyId;
